import { suggestEmail } from "../lib/emailTypo";
import { useLang } from "../contexts/LanguageContext";

export default function EmailTypoHint({ email, onAccept }) {
  const { t } = useLang();
  const suggestion = suggestEmail(email);
  if (!suggestion) return null;
  return (
    <p className="mt-2 text-sm font-light text-zinc-400" data-testid="email-typo-hint">
      {t("email_did_you_mean")}{" "}
      <button
        type="button"
        onClick={() => onAccept(suggestion)}
        className="text-sienna-400 underline underline-offset-4 hover:text-sienna"
        data-testid="email-typo-suggestion"
      >
        {suggestion}
      </button>
      ?
    </p>
  );
}
